import {
    URLASSOLUTO,
    URLASSOLUTOISTITUZIONALE,
    CURRENTROUTENAME,
    VIEWNAME,
    TEMPLATEID,
    NONCE,
} from "./variables";
//import './jquery.flexdatalist'; // messo script localmente perchè non funziona da node_modules...

$(document).ready(function () {
    $("body").on("change", ".filterblock input", function () {
        $(this)
            .closest(".filterblock")
            .find(".typeFiler")
            .prop("checked", true);
        //$(this).closest("form").submit();
        let $checked = 0;
        $(this)
            .closest(".filterblock")
            .find("input[type=checkbox]")
            .each(function () {
                if ($(this).prop("checked")) {
                    $checked = 1;
                }
            });
        if ($checked == 1) {
            $(this)
                .closest(".filterblock")
                .find(".cancella-filtra")
                .removeClass("d-none");
        } else {
            $(this)
                .closest(".filterblock")
                .find(".cancella-filtra")
                .addClass("d-none");
        }
        var form = $(this).closest("form");
        $.ajax({
            url: URLASSOLUTO + "/api/getFilter",
            data: {
                forminfo: form.serialize(),
            },
            method: "POST",
            dataType: "html",
            beforeSend: function () {
                $("#preload").fadeIn();
            },
        }).done(function (result) {
            let obj = JSON.parse(result);
            if (obj.htmlMenu !== "") {
                $(".htmlMenu").replaceWith(obj.htmlMenu);
            }
            if (obj.htmlContainer !== "") {
                $(".htmlContainer").replaceWith(obj.htmlContainer);
            }
            $("#preload").fadeOut();
        });
    });
    $("body").on("click", ".filterblock .cancella-filtra", function () {
        $(this).closest(".filterblock").find("input").prop("checked", false);
        $(this).toggleClass("d-none");

        var form = $(this).closest("form");
        //$(this).closest("form").submit();
        $.ajax({
            url: URLASSOLUTO + "/api/getFilter",
            data: {
                forminfo: form.serialize(),
            },
            method: "POST",
            dataType: "html",
            beforeSend: function () {
                $("#preload").fadeIn();
            },
        }).done(function (result) {
            let obj = JSON.parse(result);
            if (obj.htmlMenu !== "") {
                $(".htmlMenu").replaceWith(obj.htmlMenu);
            }
            if (obj.htmlContainer !== "") {
                $(".htmlContainer").replaceWith(obj.htmlContainer);
            }
            $("#preload").fadeOut();
        });
    });
    $("body").on("click", ".resetX", function () {
        productdatatable.search("").columns().search("").draw();
    });

    var productdatatable = $(".product-datatable").DataTable({
        processing: true,
        serverSide: false,
        paging: false,
        ordering: false,
        info: false,
    });
    buildSelect(productdatatable);
    productdatatable.on("draw", function () {
        buildSelect(productdatatable);
    });

    function buildSelect(table) {
        table.columns().every(function () {
            var column = table.column(this, { search: "applied" });
            var target = "";
            $(
                ".product-datatable thead tr th:nth-child(" +
                    (column.index() + 1) +
                    ")"
            ).each(function () {
                target = $(this).attr("data-target");
            });
            var header = this.header();

            if (header.classList.contains("selectfiltrable")) {
                var select = $(
                    '<select class="select2"><option value="">Seleziona...</option></select>'
                )
                    .appendTo($("." + target).empty())
                    .on("change", function () {
                        var val = $.fn.dataTable.util.escapeRegex(
                            $(this).val()
                        );

                        column
                            .search(val ? "^" + val + "$" : "", true, false)
                            .draw();
                    });

                column
                    .data()
                    .unique()
                    .sort((a, b) =>
                        ("" + a).localeCompare(b, undefined, {
                            numeric: true,
                        })
                    )
                    .each(function (d, j) {
                        select.append(
                            '<option value="' +
                                d.replace(/"/g, "&quot;") +
                                '">' +
                                d.replace(/"/g, "&quot;") +
                                "</option>"
                        );
                    });

                var currSearch = column.search();
                if (currSearch) {
                    //select.val(currSearch.substring(1, currSearch.length - 1));
                    select.val(
                        column
                            .data()
                            .unique()
                            .toArray()
                            .find((e) => e.match(new RegExp(currSearch)))
                    );
                }
            }
        });
        $(".select2").select2();
    }
});
